import React from 'react';
import ArrowNeutral from '@assets/icons/arrow-neutral.svg';
import ArrowFall from '@assets/icons/arrowfall.svg';
import ArrowRise from '@assets/icons/arrowrise.svg';
import type { CHANGE_TYPE } from '@routes/sidebar/learning/ui/dashboard-tab/___shared___/utils.ts';
import { STATISTICS_CHANGE_TYPE } from '@routes/sidebar/learning/ui/dashboard-tab/___shared___/utils.ts';
import {
    Content,
    Details,
    GamificationSectionItemWrapper,
    IconWrapper,
    Progress,
    SummarizeScore,
    Title,
} from '@routes/sidebar/learning/ui/dashboard-tab/gamification-section-item/styled.ts';

export interface Props {
    id: number;
    title: string;
    value: string;
    changeText: string;
    changeType: CHANGE_TYPE;
    icon: React.ReactNode;
}

export const GamificationSectionItem = ({ id, title, value, changeText, changeType, icon }: Props) => {
    const renderType = (type: string) => {
        switch (type) {
            case STATISTICS_CHANGE_TYPE.INCREASE:
                return <ArrowRise />;
            case STATISTICS_CHANGE_TYPE.DECREASE:
                return <ArrowFall />;
            case STATISTICS_CHANGE_TYPE.NEUTRAL:
                return <ArrowNeutral />;
            default:
                return <ArrowNeutral />;
        }
    };

    return (
        <GamificationSectionItemWrapper key={id}>
            <IconWrapper>{icon}</IconWrapper>
            <Content>
                <Title>{title}</Title>
                <Details>
                    <SummarizeScore>{value}</SummarizeScore>
                    <Progress type={changeType}>
                        {changeText}
                        {renderType(changeType)}
                    </Progress>
                </Details>
            </Content>
        </GamificationSectionItemWrapper>
    );
};
